<template>
  <v-form ref="form">
    <v-row dense class="pa-1">
        <v-col v-for="(field, i) in formCreate.preguntas" :key="i" cols="12">
            <label>¿{{field.pregunta}}?</label>
            <v-text-field v-if="field.respuesta.field == 'text'"
                v-model="field.answared"
                :rules="fieldRequired"
                outlined
                dense/>
            <v-textarea v-else-if="field.respuesta.field == 'textArea'"
                v-model="field.answared"
                :rules="fieldRequired"
                name="input-7-1"
                outlined
                dense>
            </v-textarea>
            <v-radio-group v-else-if="field.respuesta.field == 'radioButton'" v-model="field.answared" :rules="fieldRequired" row>
                <v-radio
                  v-for="value in field.respuesta.items"
                  :key="value"
                  :label="value"
                  :value="value">
                </v-radio>
            </v-radio-group>

            <v-row v-else-if="field.respuesta.field == 'checkbox'">
              <v-checkbox v-for="(value,i) in field.respuesta.items" :key="i"
                v-model="field.answared"
                :label="value"
                :value="value">
              </v-checkbox>
            </v-row>
        </v-col>
        <v-col cols="12">
            <v-layout justify-end>
                <v-btn color="error darken-1 ml-2" @click="onCancel">Cancelar</v-btn>
                <v-btn color="success darken-1 ml-2" @click="sendForm()">Guardar</v-btn>
            </v-layout>
        </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { Validate } from '@/mixins/validateFormMixin'
export default {
  props: ['formCreate', 'onSuccess', 'onCancel'],
  mixins: [Validate],
  data: () => ({
  }),
  methods: {
    sendForm () {
      if (this.$refs.form.validate()) {
        this.onSuccess(this.formCreate.preguntas)
      } else {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'ERROR',
          text: 'Hay campos obligatorios'
        })
      }
    }
  }
}
</script>

<style>

</style>
